<template>
  <div
    id="header-profile"
    class="tw-retlative tw-flex tw-items-center"
    v-if="orgDetails"
  >
    <div class="tw-relative">
      <img
        v-if="orgDetails.image"
        src="@/assets/img/notification-bell.svg"
        class="tw-w-5 tw-h-5 tw-mr-10 tw-cursor-pointer"
        alt="notification"
        @click="openNotification"
      />
      <div
        class="notification-container tw-absolute tw--top-3 tw-left-2.5 tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-bg-error tw-text-white tw-cursor-pointer"
        @click="openNotification"
        v-if="notificationCount"
      >
        <p class="tw-text-[10px]">
          {{
            notificationCount
              ? notificationCount <= 20
                ? notificationCount
                : "20+"
              : 0
          }}
        </p>
      </div>
    </div>
    <NotificationModal
      v-if="showNotification"
      :notifications="notifications"
      :loading="loading"
      :loadingMore="loadingMore"
      :unreadCount="notificationCount"
      @close="showNotification = false"
      @notification-click="handleNotificationClick"
      @load-more="loadMoreNotifications"
      @mark-all-read="markAllNotificationsRead"
    />
    <!-- <div
      v-if="showNotification"
      class="notification-dropdown tw-absolute tw-rounded tw-top-20 tw--right-0 tw-bg-white tw-w-screen sm:tw-w-96 sm:tw-right-0 tw-text-sm"
      @mouseleave="hideNotification"
      ref="notification"
    >
      <div class="tw-flex tw-justify-between tw-items-center">
        <h3 class="tw-px-4 tw-text-lg tw-font-bold tw-bg-white tw-pt-4">
          Notifications
        </h3>
        <img
          src="@/assets/img/close-dark.svg"
          class="tw-w-5 tw-h-5 tw-mr-10 tw-cursor-pointer"
          alt="close"
          @click="showNotification = !showNotification"
        />
      </div>
      <div v-if="!loading" class="tw-h-80 tw-overflow-scroll tw-pb-10 tw-mb-10">
        <div
          class="tw-flex tw-justify-between tw-items-center tw-border-t tw-rounded tw-bg-white tw-px-8 tw-py-4 tw-mt-3"
          v-for="(notification, index) in notifications"
          :key="'notification' + index"
        >
          <div class="">
            <p class="tw-text-black-light">
              <span
                v-if="!notification.read"
                class="new-tag tw-rounded-xl tw-px-2 tw-py-1 tw-mr-2"
                >New</span
              ><span class="tw-leading-6 tw-text-black tw-text-base">{{
                notification.message
              }}</span>
            </p>
            <p class="tw-text-sm tw-text-black-light tw-mt-2">
              <span
                v-if="calculateDay(notification.updatedAt) >= 1"
                class="tw-mr-1"
              >
                {{ calculateDay(notification.updatedAt) }} days
              </span>
              <span
                v-if="
                  calculateHour(notification.updatedAt) >= 1 &&
                    calculateDay(notification.updatedAt) < 1
                "
                class="tw-mr-1"
              >
                {{ calculateHour(notification.updatedAt) }} hr
              </span>
              <span
                v-if="
                  calculateMin(notification.updatedAt) < 59 &&
                    calculateHour(notification.updatedAt) < 1 &&
                    calculateDay(notification.updatedAt) < 1
                "
              >
                {{ calculateMin(notification.updatedAt) }} min
              </span>
              ago
            </p>
          </div>
        </div>
        <div ref="notificationBottom">
          <div v-if="loadingMore" class="loading tw-relative tw-h-20">
            <Loader />
          </div>
        </div>
        <div
          v-if="!loadingMore && notifications.length !== 0"
          class="tw-text-lg tw-text-center tw-mt-8"
        >
          <p>End of notification</p>
        </div>
        <div v-if="notifications.length === 0" class="tw-text-center tw-mt-8">
          <EmptyState>
            <template v-slot:message>
              <p class="message tw-text-center tw-text-gray tw-my-3">
                You have zero notifications.
              </p>
            </template>
          </EmptyState>
        </div>
      </div>
      <div v-if="loading" class="loading tw-relative tw-h-80">
        <Loader />
      </div>
    </div> -->

    <Popper offsetDistance="-10px">
      <div
        class="dropdown tw-relative tw-flex tw-flex-col tw-items-center tw-bg-gray-lightest tw-px-4 tw-py-2 tw-rounded tw-cursor-pointer"
      >
        <div class="tw-flex tw-items-center">
          <img
            v-if="orgDetails.image"
            class="tw-h-8 tw-w-8 tw-rounded-full tw-mr-2"
            :src="orgDetails.image"
            alt="profile"
            loading="lazy"
          />
          <img
            v-else
            class="tw-h-8 tw-mr-2"
            src="https://res.cloudinary.com/djalafcj9/image/upload/v1634012152/getequityV2/header-profile-img_kjtkcq.webp"
            alt="profile"
            loading="lazy"
          />
          <div v-if="!teamMember" class="syndicate-name tw-mr-4">
            <h3 class="tw-text-sm tw-hidden md:tw-inline-block">
              {{ truncate(orgDetails?.name, 12) }}
            </h3>
            <h3 class="tw-text-sm md:tw-hidden">
              {{ abbreviate(orgDetails?.name) }}
            </h3>
            <p class="tw-text-xs tw-text-gray-bg1">Admin</p>
          </div>
          <div v-else class="syndicate-name tw-mr-4">
            <h3 class="tw-text-sm tw-hidden md:tw-inline-block tw-capitalize">
              {{ truncate(`${teamMember.fname} ${teamMember.lname}`, 12) }}
            </h3>
            <h3 class="tw-text-sm md:tw-hidden tw-capitalize">
              {{ abbreviate(`${teamMember.fname} ${teamMember.lname}`) }}
            </h3>
            <p class="tw-text-xs tw-text-gray-bg1">{{ teamMember.groups[0].name }}</p>
          </div>
          <svg
            width="8"
            height="4"
            viewBox="0 0 8 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.00011 2.58602L6.47512 0.111023L7.18212 0.818023L4.00011 4.00002L0.818115 0.818023L1.52512 0.111023L4.00011 2.58602Z"
              fill="#8791A7"
            />
          </svg>
        </div>
      </div>
      <template #content="{ close }">
        <div class="tw-w-48 tw-py-4">
          <ul
            class="menu tw-text-gray tw-text-base tw-p-2 tw-bg-white tw-border tw-rounded"
          >
            <router-link
              :to="{ name: 'Account' }"
              class="list tw-cursor-pointer tw-rounded tw-px-4 tw-py-1 tw-flex tw-items-center tw-gap-2"
              @click="close"
            >
              <img
                src="@/assets/img/account.svg"
                class="tw-h-4"
                alt="account icon"
              />
              Account Settings
            </router-link>
            <li
              class="list tw-cursor-pointer tw-rounded tw-px-4 tw-py-1 tw-flex tw-items-center tw-gap-2"
              @click="logout"
              :style="{ color: '#FB2C36' }"
            >
              <img
                src="@/assets/img/logout.svg"
                class="tw-h-3"
                alt="logout icon"
              />
              Logout
            </li>
          </ul>
        </div>
      </template>
    </Popper>
  </div>
</template>

<script>
import NotificationModal from "@/components/notification/NotificationModal.vue";
import {
  abbreviate,
  truncate,
} from "@/utils/helpers.js";
import { getItem } from "@/utils/storage";
import { mapActions, mapState } from "vuex";
import Popper from "vue3-popper";

export default {
  name: "HeaderProfile",

  components: { NotificationModal, Popper },

  data() {
    return {
      loading: false,
      loadingMore: false,
      page: 1,
      limit: 10,
      notifications: [],
      page: 1,
      pages: 0,
      syndicateName: "",
      showNotification: false,
      teamMember: null,
    };
  },

  computed: {
    ...mapState({
      orgDetails: (state) => state.organisationModule.organisationDetails,
      notificationCount: (state) => state.organisationModule.notificationCount,
    }),
  },

  created() {
    this.setDetails();

    try {
      const teamMemberData = getItem("team_member");

      if (teamMemberData) {
        this.teamMember = teamMemberData;
        if (!this.teamMember || typeof this.teamMember !== "object") {
          this.teamMember = null;
          console.log("Team member data is invalid or empty");
        }
      } else {
        this.teamMember = null;
      }
    } catch (e) {
      this.teamMember = null;
      console.error("Error processing team member data:", e);
    }
  },

  watch: {
    showNotification(val) {
      if (!val) {
        this.getTotalUnreadNotifications();
      }
    },
  },

  methods: {
    ...mapActions("organisationModule", [
      "setOrganisationProfile",
      "getNotifications",
      "getTotalUnreadNotifications",
    ]),
    ...mapActions(["logout"]),

    truncate,
    abbreviate,

    setDetails() {
      const details = getItem("org_details");
      this.setOrganisationProfile(details);
      this.getTotalUnreadNotifications();
    },

    openNotification() {
      this.page = 1;
      this.notifications = {};
      this.showNotification = true;
      this.loading = true;
      this.fetchNotifications().then(() => {
        // Mark all as read in background so bell count resets on close;
        // local notification read state is preserved for this session
        this.markAllNotificationsRead();
      });
    },

    // async fetchNotifications() {
    //   const response = await this.getNotifications({
    //     page: this.page,
    //     limit: this.limit,
    //   });
    //   if (response) {
    //     const { page, pages, notifications } = response.data.data;
    //     this.notifications = this.notifications.concat(notifications);
    //     this.page = page;
    //     this.pages = pages;
    //     setTimeout(() => {
    //       this.setObserver();
    //     }, 100);
    //   }
    //   if (this.loading) this.loading = false;
    //   if (this.loadingMore) this.loadingMore = false;
    // },
    async fetchNotifications() {
      const response = await this.getNotifications({
        page: this.page,
        limit: this.limit,
      });
      if (response) {
        let dates = [];
        let group = {};
        const { page, pages, notifications } = response.data.data;
        notifications.map((notification, index) => {
          if (!dates.includes(notification.createdAt.split("T")[0])) {
            let date = notification.createdAt.split("T")[0];
            dates.push(notification.createdAt.split("T")[0]);
            let groupArray = notifications.filter(
              (noti) => date === noti.createdAt.split("T")[0]
            );
            group[date] = groupArray;
          }
        });
        this.notifications = { ...this.notifications, ...group };
        this.page = page;
        this.pages = pages;
      }
      if (this.loading) this.loading = false;
      if (this.loadingMore) this.loadingMore = false;
    },

    hideNotification() {
      this.timeout = setTimeout(() => {
        this.showNotification = false;
      }, 2000);
    },

    handleNotificationClick(notification) {
      // Handle invitation/gift clicks
      if (notification.type === 'Esop Invitation' || notification.type === 'Invitation') {
        if (!notification.raw?.status || notification.raw.status === 'Pending') {
          // Navigate to invitation review page or show modal
          console.log('Review invitation:', notification);
        }
      } else if (notification.type === 'Gift') {
        // Handle gift notification click
        console.log('Gift notification:', notification);
      }
    },

    loadMoreNotifications() {
      if (this.page < this.pages && !this.loadingMore) {
        this.loadingMore = true;
        this.page += 1;
        this.fetchNotifications();
      }
    },

    markAllNotificationsRead() {
      this.$store.dispatch("organisationModule/markAllNotificationsRead");
    },
  },
};
</script>

<style lang="scss" scoped>
#header-profile {
  .notification-container {
    border-radius: 50%;

    .notification-count {
      left: 50%;
      transform: translate(-50%, -0%);
    }
  }

  .menu {
    .list {
      transition: 0.3s ease all;
      font-size: 14px;

      &:hover {
        color: #375cb1;
      }
    }
  }

  &:hover .menu {
    display: block;
  }
}
</style>
